import { useQueryClient, useMutation } from "@tanstack/react-query";

import logger from "../../../../logger";

export const transcriptKeys = {
  all: ["transcripts"],
  lists: () => [...transcriptKeys.all, "list"],
  list: (filters) => [...transcriptKeys.lists(), { filters }],
  items: () => [...transcriptKeys.all, "item"],
  item: (transcriptId) => [...transcriptKeys.items(), transcriptId],
};

// Mutations
export function useCreateTranscript(func) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: transcriptKeys.lists() });
    },
  });
}
